import { render, staticRenderFns } from "./AsideFilter.vue?vue&type=template&id=32589ebf&scoped=true&"
import script from "./AsideFilter.vue?vue&type=script&lang=js&"
export * from "./AsideFilter.vue?vue&type=script&lang=js&"
import style0 from "./AsideFilter.vue?vue&type=style&index=0&id=32589ebf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32589ebf",
  null
  
)

export default component.exports